import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button } from '@govtechsg/sgds-react/Button'
//import { Footer } from '@govtechsg/sgds-react'
import { Helmet } from "react-helmet-async";
import { CopyBlock , a11yLight, github} from 'react-code-blocks';

// Components
import HeaderRegComponent from '../../Components/HeaderRegComponent'
import FooterComponent from '../../Components/FooterComponent'
import workshopImage from '../../images/blog/workshop_may_2025.jpeg';
import formlinkImage from '../../images/blog/gogovsg_link.png';
import  onemapPresentation1 from '../../images/blog/OneMap Presentation for OneMap API Workshop 290525.pdf';
import  onemapPresentation2 from '../../images/blog/OneMap_WorkshopDemo_May_2025.pdf';

const TokenManagement = () => { 
    const codeSnippet = `
        const getAccessToken = async () => {
            try {
                const response = await axios.post(
                \`\${process.env.ONEMAP_BASE_URL}/api/auth/post/getToken\`,
                {
                    email: process.env.ONEMAP_API_EMAIL,
                    password: process.env.ONEMAP_API_PASSWORD,
                }
                );

                const accessToken = response.data.access_token;
                setAccessToken(accessToken); // Cache the token for reuse
                return accessToken;
            } catch (error) {
                console.error("Error refreshing token:", error);
                throw new Error("Unable to refresh token");
            }
        };`;
    const codeSnippet2 = `
        // Example utility functions
        let inMemoryToken = null;

        export const setAccessToken = (token) => {
        inMemoryToken = token;
        };

        export const getInMemoryAccessToken = () => inMemoryToken;
    `;

    const codeSnippet3 = `
        import axios from "axios";
        import https from "https";

        export default async function handler(req, res) {
        const { method } = req;
        const targetUrl = \`\${process.env.ONEMAP_BASE_URL}/\${req.query.externalUrl}\`;
        let access_token = getInMemoryAccessToken();

        try {
            const response = await axios({
            method,
            url: targetUrl,
            headers: {
                Authorization: \`\${access_token}\`,
                "Content-Type": "application/json",
            },
            params: req.query,
            });

            res.status(response.status).json(response.data);
        } catch (error) {
            if (error.response?.status === 401) {
            try {
                access_token = await getAccessToken();
                const retryResponse = await axios({
                method,
                url: targetUrl,
                headers: {
                    Authorization: \`\${access_token}\`,
                    "Content-Type": "application/json",
                },
                params: req.query,
                });

                res.status(retryResponse.status).json(retryResponse.data);
            } catch (retryError) {
                res.status(retryError.response?.status || 500).json({
                message: retryError.message,
                details: retryError.response?.data,
                });
            }
            } else {
            res.status(error.response?.status || 500).json({
                message: error.message,
                details: error.response?.data,
            });
            }
        }
        }
    `;
  	return (
		<>
		<Helmet>
        <title>OneMap Workshop – May 2025| OneMap API</title>
        <meta
          name="description"
          content="OneMap Workshop, Unlocking the Power of Geospatial Data for Government and Businesses"
        />
      </Helmet>
		<div className="om-body container-fluid">

			<HeaderRegComponent />

			<div className="om-body-content pageBase">
                <div className='blog center om-body-container'>
                    <div className='row mb-4'>
                        <div class="col-md-10 offset-md-1">

                        <img className="img-fluid w-100" src={workshopImage} alt='intro' />
                        <h2 style={{marginTop: "30px"}}>Unlocking the Power of Geospatial Data for Government and Businesses</h2>
                        <p>In May 2025, the Singapore Land Authority (SLA) hosted the OneMap Workshop, bringing together participants from various government agencies and private sector organizations. This initiative was part of SLA’s ongoing commitment to promoting the use of geospatial data and services through OneMap, Singapore’s authoritative national map platform.</p>


                        <h2>Purpose of the Workshop</h2>
                        <p>The primary objective of the workshop was to showcase how OneMap’s suite of APIs can be used to build powerful, location-based applications. By opening access to OneMap’s rich geospatial datasets, the event aimed to foster innovation, improve service delivery, and enable smarter decision-making across both public and private sectors.</p>

                        <h2>Who Attended</h2>
                        <p>The event drew a diverse crowd — including government officers involved in urban
                        planning, healthcare services, and public infrastructure, as well as private sector
                        professionals from logistics, real estate, and technology companies.</p>

                        <h2>Key Highlights</h2>
                        <h3>1. Introduction to OneMap API</h3>
                        <p>Participants were introduced to the range of APIs provided by OneMap, including:</p>
                        <ul>
                            <li>Geocoding and Reverse Geocoding APIs</li>
                            <li>Routing and Navigation Services</li>
                            <li>Thematic Layers for Planning Areas, Land Use, and Demographics</li>
                        </ul>
                        <p>These APIs enable developers to integrate highly accurate Singapore-specific geospatial data into their web or mobile applications with ease.</p>

                        <h3>2. Demo Code and Use Case Sharing</h3>
                        <p>We also shared <b>demo code samples and live application walkthroughs</b> to help
                        participants understand how to practically implement the OneMap API.</p>

                        <p>All demo code and resources were made available to participants: 
                        &nbsp;<a href='https://github.com/andikasun/onemap-workshop-may-2025'>https://github.com/andikasun/onemap-workshop-may-2025</a></p>
                        
                        <h2>Looking Ahead</h2>
                        <p>The OneMap Workshop highlighted how geospatial data is no longer just for maps
                        — it's an enabler for innovation in transportation, public safety, smart cities, real
                        estate, and more. Whether you’re from the public or private sector, OneMap offers
                        tools that can be tailored to a wide array of business and operational needs.</p>
                        <p>We look forward to more collaborations and will continue supporting the community
                        in harnessing the full potential of geospatial data through OneMap.</p>
                        <p>If you missed the workshop or would like to get started, feel free to contact us for
                        more information and developer access.</p>

                        <h2>Connect with OneMap</h2>
                        <p>For those looking to implement OneMap in their own systems, our team is here to
                        help. We encourage developers and data teams to reach out to us for:</p>
                        <ul>
                            <li><b>Technical guidance and support</b> on integrating OneMap APIs</li>
                            <li><b>Best practices and consultation</b> on applying geospatial intelligence in your business use case.</li>
                        </ul>

                        <img className="img-fluid" src={formlinkImage} alt='intro' />
                        <br/><a href={onemapPresentation2}>OneMap Presentation for OneMap API Workshop 290525.pdf</a><br/>
                        <a href={onemapPresentation2}>OneMap_WorkshopDemo_May_2025.pdf</a>

                        
                        <div style={{marginBottom:"7em"}}/>
 
                    </div>
                </div>
            </div>
        </div>

			<FooterComponent />

		</div>
		</>
	)
}

export default TokenManagement